import { render } from "./WirepasAnchorPlacementGrid.vue?vue&type=template&id=574c77eb&scoped=true&ts=true"
import script from "./WirepasAnchorPlacementGrid.vue?vue&type=script&lang=ts"
export * from "./WirepasAnchorPlacementGrid.vue?vue&type=script&lang=ts"

import "./WirepasAnchorPlacementGrid.vue?vue&type=style&index=0&id=574c77eb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574c77eb"]])

export default __exports__